import { useEffect } from 'react'
import { bindYmClickTracking } from '../ym'

export function YmClickTracker() {
  useEffect(() => bindYmClickTracking(), [])

  return null
}
